export default "__VITE_ASSET__UNBHKPZI__"